// Stub sentry module — Sentry integration disabled for now.
// Note: keep the ErrorBoundary stub even when disabled — main.jsx renders
// `<Sentry.ErrorBoundary>` and React throws "Element type is invalid" if it's missing.
export function initSentry() {}
export const Sentry = {
  captureException: () => {},
  captureMessage: () => {},
  ErrorBoundary: ({ children }) => children,
};
